import script from "./ModalEventList.vue?vue&type=script&setup=true&lang=ts"
export * from "./ModalEventList.vue?vue&type=script&setup=true&lang=ts"

import "./ModalEventList.vue?vue&type=style&index=0&id=ff404484&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\a-okamura\\Documents\\project\\JuchuAppFront\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff404484"]])

export default __exports__